// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YDhPo","photo-container":"styles_photo-container__2Da_j","pagetitle":"styles_pagetitle__1fPZS"};